import { render } from "./Intern.vue?vue&type=template&id=80386b5a"
import script from "./Intern.vue?vue&type=script&lang=js"
export * from "./Intern.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/kingdomIn/Intern.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "80386b5a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('80386b5a', __exports__)) {
    api.reload('80386b5a', __exports__)
  }
  
  module.hot.accept("./Intern.vue?vue&type=template&id=80386b5a", () => {
    api.rerender('80386b5a', render)
  })

}


export default __exports__